import { Component } from '@angular/core';

@Component({
  selector: 'app-organizer-reviews',
  templateUrl: './organizer-reviews.component.html',
})
export class AttendeeOrganizerReviewsComponent {}
